import { useSupercluster } from '../hooks/use-supercluster'
import { useMap } from '@vis.gl/react-google-maps'
import { DeckGlOverlay } from './deckgl-overlay'
import { DeckGlLayers } from './deckgl-layers'

const superclusterOptions = {
    extent: 400,
    radius: 25,
    maxZoom: 8,
    minPoints: 10
}

export const ClusteredMarkers = ({ data, gateListings }) => {
    const map = useMap()
    const { clusters, getLeaves, getClusterExpansionZoom } = useSupercluster(data, superclusterOptions)
    const handleClusterClick = (marker) => {
        const leaves = getLeaves(marker.properties?.cluster_id)
        const zoom = getClusterExpansionZoom(marker.properties?.cluster_id)
        setTimeout(() => {
            map.setZoom(zoom)
            map.panTo({ lat: +leaves[0].lat, lng: +leaves[0].lng })
        }, 150)
        
    }

    const handleMarkerClick = (marker) => {
        const url = marker?.link
        if (url) {
            window.open(url, '_blank')
        }
    }


    return (
        <>
            <DeckGlOverlay layers={DeckGlLayers(clusters, gateListings, handleClusterClick, handleMarkerClick)} />   
        </>
    )
}
